import { render } from "./GoalsPage.vue?vue&type=template&id=e5fb5290&scoped=true"
import script from "./GoalsPage.vue?vue&type=script&lang=js"
export * from "./GoalsPage.vue?vue&type=script&lang=js"

import "./GoalsPage.vue?vue&type=style&index=0&id=e5fb5290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5fb5290"]])

export default __exports__